import { useTranslation, withTranslation } from "react-i18next";
import "./informes.scss"
import {Button, Col, Input, Radio, Row, Space} from "antd";
import {
    FileExcelOutlined,
    SearchOutlined,
    WarningOutlined
} from "@ant-design/icons";
import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dataActions } from "../../../_actions";
import { v1 as uuidv1 } from "uuid";
import { xcService } from "../../../_services/xcService";
import * as _ from "lodash";
import Select from 'react-select';
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import variables from "../../../_constants/variables";
import DownloadExcel from "./datos/excel";
import DownloadExcelTable from "./datos/exceltable";
import config from "_config/config.js";


function DescargaExcel() {
    const { t } = useTranslation();
    const ref = React.createRef();
    const dispatch = useDispatch();
    const storage = localOrSessionStore({ key: variables.REMEMBER });
    const userType = storage.getItem(variables.USER_TYPE);
    const [isLoadingCode, setIsLoadingCode] = useState(false);
    const [degreeData, setDegreeData] = useState([]);
    const [tipoInforme, setTipoInforme] = useState(null);
    const [courseSel, setCourseSel] = useState(null);
    const [courseFinSel, setCourseFinSel] = useState(null);

    const [quest, setQuest] = useState(null);
    const [yearSel, setYearSel] = useState(null);
    const [yearFinSel, setYearFinSel] = useState(null);
    const [isGenerating, setIsGenerating] = useState(false);
    const [genSel, setGenSel] = useState([]);
    const [years, setYears] = useState([]);
    const [totalAlumnos, setTotalAlumnos] = useState(0);
    const [dataInforme, setDataInforme] = useState(null);
    const [datanoFormat, setDatanoFormat] = useState(null);
    const [allData, setDataAll] = useState(null);
    const [dataExcel, setDataExcel] = useState([])
    const [isClicked, setIsClicked] = useState(false)
    const [allAssessments, setAllAssessments] = useState(null);
    const [allCodes, setAllCodes] = useState([]);
    const [isSearch, setIsSearch] = useState(false);
    const [loadingExcel, setLoadingExcel] = useState(true);
    const [cXelence, setcXelence] = useState(false);
    const [cValidados, setcValidados] = useState(false);
    const [cValidar, setcValidar] = useState(false);
    const [cIncompleto, setcIncompleto] = useState(false);
    const [codeLoaded, setCodeLoaded] = useState(false)
    const [getting, setGetting] = useState(false);
    const [firstTime, setFirstTime] = useState(true);
    const [towns, setTowns] = useState([]);
    const [provinces, setProvinces] = useState([]);
    const [ccaa, setCCAA] = useState([]);
    const [allDegress, setAllDegrees] = useState([])
    const [isFiltered, setFiltered] = useState(false);

    const [dataLoaded, setDataLoaded] = useState(false);

    const [cTowns, setcTowns] = useState([]);
    const [cProvince, setcProvince] = useState([]);
    const [cCCAA, setcCCAA] = useState([]);
    const [codes, setCodes] = useState([]);
    const [degree, setDegree] = useState(null);
    const [degreeCode, setDegreeCode] = useState([])

    const [unis, setUnis] = useState([]);
    const [fps, setFps] = useState([]);

    const [codeExcel, setCodeExcel] = useState(null);
    const [json, setJson] = useState(null);
    const [oldProcess, setOldProcess] = useState(null);

    const [courses, setCourses] = useState([]);
    const interval = useRef();

    //Socket
    const socket = useRef();

    var coursesData = useSelector((state) => state.dataReducer.coursesData);

    function onlyUnique(value, index, self) {
        return self?.indexOf(value) === index;
    }

    const getYears = () => {
        xcService.get(`/v1/years`).then(({ data }) => {
            setYears(data.data)
        })


    }

    const getDataFilter = () => {
        if (userType === "MASTER") {
            xcService.getToken(`/v1/master/centercodes`).then(({ data }) => {

                setAllCodes(data.data.map(c => {
                    return {
                        label: c.code + " - " + c.name,
                        value: c.code
                    }
                }))
                setProvinces(data.data.map(item => item.province).filter(onlyUnique).map(ccaa => {
                    return {
                        text: ccaa,
                        value: ccaa
                    }
                }))
                setTowns(data.data.map(item => item.town).filter(onlyUnique).map(ccaa => {
                    return {
                        text: ccaa,
                        value: ccaa
                    }
                }))
                setCCAA(data.data.map(item => item.ccaa).filter(onlyUnique).map(ccaa => {
                    return {
                        text: ccaa,
                        value: ccaa
                    }
                }))
            })
        }
        xcService.getToken(`/v1/${userType === 'MASTER' ? 'master' : 'tutor'}/allassessments`).then(({ data }) => {

            setAllAssessments(data.data)
        })
    }

    useEffect(() => {
        getYears()
        getDataFilter();


        if (!coursesData) getCourses();
    }, []);


    const getDataExcel = (payload) => {
        setCodeExcel(null);
        setDataExcel([])
        setDataLoaded(false)
        setCodeLoaded(false)
        setGetting(true)
        localStorage.removeItem("CODEJSON")
        xcService.postToken(`/v1/${userType === 'MASTER' ? 'master' : 'tutor'}/informes/excel/data`, payload).then(({ data }) => {
            setCodeLoaded(true);
            setCodeExcel(data.data.code);
            localStorage.setItem("CODEJSON",data.data.code)

            interval.current = setInterval(() => {

               callFinish();
            }, 18000);



        }).catch(err => setLoadingExcel(false))
    };

    const callFinish = () => {
        if (localStorage.getItem("CODEJSON")) {
            xcService.postToken(`/v1/${userType === 'MASTER' ? 'master' : 'tutor'}/excel/${localStorage.getItem("CODEJSON")}`, {}).then(({data}) => {
                if (data.data.finish && data.data.finish === true) {
                    //setCodeExcel(null);
                    setDataLoaded(true)
                    setGetting(false);
                    setFiltered(false);
                    clearInterval(interval.current);
                }

            }).catch(err => setLoadingExcel(false))
        }else{
           // clearInterval(interval.current);
        }

    }

    const goToFile = (code) => {

        window.location.href = config.backendUrl + "/public/" + code + ".xlsx";
    }

    const checkCode = () => {
        setIsLoadingCode(true);
        getDataCode()
    }

    const getDataCode = () => {
        xcService.postToken(`/v1/${userType === 'MASTER' ? 'master' : 'tutor'}/excel/${localStorage.getItem("CODEJSON")}`).then(({ data }) => {
            setIsLoadingCode(false);
            setLoadingExcel(false)
            if (data.data.finish || data.data.finish === "true" || data.data.finish === true) {

                setDataExcel(data.data.salida.sort((a, b) => moment(a.updatedAt).format('YYYYMMDD') - moment(b.updatedAt).format('YYYYMMDD')));

                if (data.data.salida.length > 0) {
                    localStorage.removeItem("CODEJSON")
                    setDataLoaded(true)
                    setGetting(false);
                    setFiltered(false);

                    //  setIsGenerating(false);
                }
            } else {

            }
        }).catch(err => setLoadingExcel(false))
    }

    useEffect(() => {
        if (coursesData) setCourses(coursesData);
    }, [coursesData]);


    useEffect(() => {
        if (coursesData) {
            setCourses(coursesData);

            Promise.all(['FPB', 'CFGM', 'CFGS', 'UNIV'].map(code => xcService.getToken(`/v1/degree/${code}`)))
                .then(res => setDegreeData(res.map(({ data }) => data.data).flat()))


        }
    }, [coursesData]);


    useEffect(() => {
        if (degreeData) {
            setUnis(degreeData.filter(it => it.degree === "UNIV").map(c => {
                return {
                    label: c.title,
                    value: c.code
                }
            }));
            setFps(degreeData.filter(it => it.degree !== "UNIV").map(c => {
                return {
                    label: c.title,
                    value: c.code
                }
            }));

        }
    }, [degreeData]);


    const getCourses = () => {
        dispatch(dataActions.getCourses());
    };

    const getCourseName = () => {

        let mResult = _.filter(courses, function (o) {
            return o.id === courseSel
        });
        return mResult[0].name;

    }
    const changeCourseFin  = (val) => {
        setDataLoaded(false)
        setDataExcel([]);
        setFiltered(false)
        setCourseFinSel(val)

    }

    const changeCourse = (val) => {
        setDataLoaded(false)
        setDataExcel([]);
        setFiltered(false)
        setCourseSel(val)

    }

    const onChangeYears = (checkedValues) => {
        setDataLoaded(false)
        setDataExcel([]);
        setFiltered(false)
        setYearSel(checkedValues)
    };

    const onChangeYearsFin = (checkedValues) => {
        setDataLoaded(false)
        setDataExcel([]);
        setFiltered(false)
        setYearFinSel(checkedValues)
    };

    const clearYears = () => {
        setDataLoaded(false)
        setDataExcel([]);
        setFiltered(false)
        setYearSel(null)
        setYearFinSel(null)
    }

    const changeGen = (val) => {
        setGenSel(val)

    }


    const clearFilters = () => {

        setcTowns([]);
        setcProvince([]);
        setcCCAA([]);
        setCodes([]);
        setcIncompleto(false);
        setcValidar(false);
        setcValidados(false);
        setcXelence(false);
        setFiltered(false);


    }

    const onChangeAcc = (key) => {
    };

    const onChangeTowns = (value) => {
        setcTowns(value);
    };

    const onChangeCode = (value) => {
        setDataLoaded(false)
        setDataExcel([]);
        setFiltered(false)
        setCodes(value);
    };

    const borrarDegree = () => {
        setDataLoaded(false)
        setDataExcel([]);
        setFiltered(false)
        setDegree(null);
        setDegreeCode(null);
    }

    const onChangeDegreeCode = (value) => {
        setDataLoaded(false)
        setDataExcel([]);
        setFiltered(false)
        setDegreeCode(value);
    };

    const onChangeDegree = (value) => {
        setDataLoaded(false)
        setDataExcel([]);
        setDegreeCode([])
        setDegree(value);
    };

    const onChangeProvince = (value) => {
        setcProvince(value);
    };
    const onChangeCCAA = (value) => {
        setcCCAA(value);
    };
    const onChangeIncompleto = (e) => {

        setcIncompleto(e.target.checked)
    };
    const onChangeValidar = (e) => {
        setcValidar(e.target.checked);
    };
    const onChangeValidados = (e) => {
        setcValidados(e.target.checked)
    };
    const onChangeXcelence = (e) => {
        setcXelence(e.target.checked)
    };

    const clearCourse = () => {
        setDataLoaded(false)
        setDataExcel([]);
        setFiltered(false)
        setCourseSel(null);
        setDegreeCode([])
        setDegree(null)
    }

    const applyFilter = (c, y) => {
        setIsClicked(true)
        setDataInforme(null);
        setFiltered(true)
        setLoadingExcel(true)

        let mYears = [];
        if (y) {
            let mFin = yearFinSel ? yearFinSel : y;
            let mInicio = y;
            while (mInicio <= mFin) {
                mYears.push(mInicio);
                mInicio++
            }
        }

        let mPayload = {

            year: mYears,
            codes: codes ? codes.value : null,
            course: courseSel,
            courseEnd: courseFinSel,
            degree: degree,
            degreeCode: degreeCode ? degreeCode.value : null
        }
        getDataExcel(mPayload)
    }

    const exportData = () => {

        const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
            JSON.stringify(dataExcel)
        )}`;
        const link = document.createElement("a");
        link.href = jsonString;
        link.download = "data" + moment().format(("YYYYMMDD")) + ".json";

        link.click();
    };

    const changeValueProcess = (e) => {
        setOldProcess(e.target.value)
    }
    const [oldProcessOk, setOldProcessOk] = useState(false)
    const checkOld = () => {
        xcService.postToken(`/v1/${userType === 'MASTER' ? 'master' : 'tutor'}/excel/${oldProcess}`).then(({ data }) => {
            if (data.data.finish || data.data.finish === "true" || data.data.finish === true) {
                setOldProcessOk(true);
            } else {
                setOldProcessOk(false)
            }
        }).catch(err => setOldProcessOk(false))
    }

    return (
        <div className="container dasboard-informes dasboard-informes--admin">
            <div className={"gridInformes"}>
                <div style={{ padding: 30, width: "100%" }}>
                    <Row>
                        <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                            <div>
                                <h5 className={"informes subtitle"}>{t("login.course")}<span
                                    style={{ color: 'red' }}>*</span></h5>
                            </div>
                            <Radio.Group className={"container-filters"}
                                onChange={(value) => changeCourse(value.target.value)}
                                value={courseSel}>
                                <Space direction="vertical">
                                    {courses.map(item => {
                                        return <Radio key={uuidv1()} value={item.id}>{item.name}</Radio>
                                    })}
                                </Space>
                            </Radio.Group>

                            <div>
                                <h5 className={"informes subtitle"}>{t("login.course")} fin<span
                                    style={{ color: 'red' }}>*</span></h5>
                            </div>
                            <Radio.Group className={"container-filters"}
                                         onChange={(value) => changeCourseFin(value.target.value)}
                                         value={courseFinSel}>
                                <Space direction="vertical">
                                    {courses.map(item => {
                                        return <Radio key={uuidv1()} value={item.id}>{item.name}</Radio>
                                    })}
                                </Space>
                            </Radio.Group>
                            <Button onClick={() => clearCourse()}>{t("borrarfiltros")}</Button>
                        </Col>
                        <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                            <div><h5 className={"informes subtitle"}>{t("datos.recorrido")}</h5></div>
                            <h6>{t("datos.yearini")}</h6>
                            <Radio.Group className={"container-filters"}
                                onChange={(value) => onChangeYears(value.target.value)}
                                value={yearSel}>
                                <Space direction="vertical">
                                    {years.map(item => {
                                        return <Radio key={item.year}
                                            value={item.year}>20{item.year}/20{+item.year + 1}</Radio>
                                    })}
                                </Space>
                            </Radio.Group>
                            {courseFinSel &&
                                <>
                                    <h6>{t("datos.yearfin")}</h6>
                                    <Radio.Group className={"container-filters"}
                                        onChange={(value) => onChangeYearsFin(value.target.value)}
                                        value={yearFinSel}>
                                        <Space direction="vertical">
                                            {years.map(item => {
                                                return <Radio key={item.year}
                                                    value={item.year}>20{item.year}/20{+item.year + 1}</Radio>
                                            })}
                                        </Space>
                                    </Radio.Group>
                                </>
                            }
                            <Button onClick={() => clearYears(null)}>{t("borrarfiltros")}</Button>
                        </Col>
                    </Row>
                    {userType === "MASTER" &&
                        <Row>
                            <Col xs={24} sm={12} md={12} lg={12} xl={12} style={{ paddingTop: 10, paddingRight: 40 }}>

                                <>
                                    <div>
                                        <h5 className={"informes subtitle"}>{t("filtro.codigo")}</h5>
                                    </div>
                                    {allCodes && allCodes.length > 0 &&
                                        <Select
                                            value={codes}
                                            style={{ width: "50%" }}
                                            allowClear
                                            placeholder={t("filtro.codigo")}
                                            optionFilterProp="children"
                                            onChange={onChangeCode}

                                            options={allCodes}

                                        />
                                    }
                                </>
                            </Col>

                            <Col xs={24} sm={12} md={12} lg={12} xl={12} style={{ marginTop: 10 }}>

                                {courseSel && !yearFinSel &&
                                    <>
                                        <div><h5 className={"informes subtitle"}>{t("datos.tipoEstudio")}</h5></div>

                                        <div><h6 className={"informes subtitle"}>{t("datos.tipoEstudios")}</h6></div>
                                        <Radio.Group className={"container-filters"}
                                            onChange={(value) => onChangeDegree(value.target.value)}
                                            value={degree}>
                                            <Space direction="vertical">
                                                <Radio key={uuidv1()} value={"UNIV"}>{t("datos.carrera")}</Radio>
                                                <Radio key={uuidv1()} value={"FP"}>{t("datos.cicloformativo")}</Radio>
                                            </Space>
                                        </Radio.Group>
                                        {degree &&
                                            <>
                                                <Select
                                                    value={degreeCode}
                                                    style={{ width: "90%" }}
                                                    allowClear
                                                    optionFilterProp="children"
                                                    onChange={onChangeDegreeCode}

                                                    options={degree === "UNIV" ? unis : fps}

                                                />
                                            </>}
                                        <Button onClick={() => borrarDegree()}>{t("borrarfiltros")}</Button>
                                    </>}
                            </Col>
                        </Row>
                    }

                    <Row>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ textAlign: "center" }}>
                            <Button style={{ marginTop: 15, margin: "auto" }} disabled={!courseSel || !yearSel}
                                onClick={() => applyFilter(courseSel, yearSel)} type="primary"
                                icon={<SearchOutlined />}>
                                {t("datos.aplicar")}
                            </Button>

                        </Col>

                    </Row>
                    <Row>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ textAlign: "center" }}>

                            <div style={{ margin: "auto", marginTop: 20 }}>
                                {isFiltered && getting &&

                                    <Button style={{ marginTop: 15, margin: "auto" }} loading className={"btnWhiteBlue"}>
                                        {t("generandop")}
                                    </Button>
                                }

                                {codeLoaded  &&
                                    <>
                                        <div>Se está generando el informe. El código de petición es: <strong>{codeExcel}</strong>. Apúntalo si lo quieres recuperar más tarde.</div>
                                    </>

                                }

                                {dataLoaded &&
                                    <>

                                        <Button style={{ margin: "auto", marinTop: 20 }} onClick={() => goToFile(localStorage.getItem("CODEJSON"))} icon={<FileExcelOutlined />}
                                            className={"btnWhiteBlue"}>Exportar datos a XLS
                                        </Button>

                                        {userType === "MASTER" && 1 === 2 &&
                                            <Button onClick={() => exportData()} style={{marginTop: 15, margin: "auto"}}  className={"btnWhiteBlue"}>
                                                {"Descargar JSON"}
                                            </Button>

                                        }

                                        {1 === 2 && <DownloadExcelTable style={{ marginTop: 15, margin: "auto" }}
                                            tipoInforme={"all"}
                                            dataLoaded={dataLoaded}
                                            name={""}
                                            course={courseSel}
                                            dataExcel={dataExcel} />
                                        }
                                        {1 == 2 && <DownloadExcel name={""} course={courseSel}

                                                                  tipoInforme={"all"}
                                                                  dataExcel={dataExcel}/>}


                                    </>
                                }

                                {isFiltered && !loadingExcel && (!dataExcel || dataExcel.length === 0) &&
                                    <Button style={{ marginTop: 15, margin: "auto" }} icon={<WarningOutlined />}
                                        className={"btnWhiteBlue"}>
                                        {t("sindatos")}
                                    </Button>

                                }
                                <div style={{width: 200}}>
                                    Recuperar un proceso anterior:
                                    <div>
                                        <Input placeholder="Código de proceso" onChange={changeValueProcess}  />
                                    </div>
                                    <div>
                                        <Button onClick={() => checkOld()} style={{marginTop: 15, margin: "auto"}}  className={"btnWhiteBlue"}>
                                          Comprobar
                                        </Button>
                                        {oldProcessOk &&
                                            <Button style={{ margin: "auto", marinTop: 20 }} onClick={() => goToFile(oldProcess)} icon={<FileExcelOutlined />}
                                                    className={"btnWhiteBlue"}>Exportar datos a XLS
                                            </Button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </Col>

                    </Row>
                </div>
            </div>
        </div>)

}

export default withTranslation()(DescargaExcel)
